var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#183883"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1739_40515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1739_40515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1 24.05C12.7333 23.4167 12.4583 22.7667 12.275 22.1C12.0917 21.4333 12 20.75 12 20.05C12 17.8167 12.775 15.9167 14.325 14.35C15.875 12.7833 17.7667 12 20 12H20.175L18.575 10.4L19.975 9L23.975 13L19.975 17L18.575 15.6L20.175 14H20C18.3333 14 16.9167 14.5875 15.75 15.7625C14.5833 16.9375 14 18.3667 14 20.05C14 20.4833 14.05 20.9083 14.15 21.325C14.25 21.7417 14.4 22.15 14.6 22.55L13.1 24.05ZM20.025 31L16.025 27L20.025 23L21.425 24.4L19.825 26H20C21.6667 26 23.0833 25.4125 24.25 24.2375C25.4167 23.0625 26 21.6333 26 19.95C26 19.5167 25.95 19.0917 25.85 18.675C25.75 18.2583 25.6 17.85 25.4 17.45L26.9 15.95C27.2667 16.5833 27.5417 17.2333 27.725 17.9C27.9083 18.5667 28 19.25 28 19.95C28 22.1833 27.225 24.0833 25.675 25.65C24.125 27.2167 22.2333 28 20 28H19.825L21.425 29.6L20.025 31Z",
    fill: "#183883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.7689d71571930039a46ef404785b2710.svg";
export { ForwardRef as ReactComponent };